// Hotjar tracking script
//    - @author Miguel Manuel Salvador Rubio <miguel.manuel.salvador.rubio@hp.com>
//    - @date February 13th, 2024
//    - @copyright Copyright (c) HP Inc, 2023
//        All rights reserved. Copying or other reproduction of this program except
//        for archival purposes is prohibited without written consent of HP Inc.
export const Hotjar = {
  init: (ID) => {
    // Only insert Hotjar script if not already present
    if (
      !window.hj &&
      !document.querySelector(
        'script[src*="static.hotjar.com/c/hotjar-' + ID + '.js?sv=6"]'
      )
    )
      (function (h, o, t, j, a, r) {
        h.hj =
          h.hj ||
          function () {
            (h.hj.q = h.hj.q || []).push(arguments);
          };
        h._hjSettings = { hjid: ID, hjsv: 6 };
        a = o.getElementsByTagName('head')[0];
        r = o.createElement('script');
        r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
      })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  }
};
